import { Component } from 'react';
import { ELSModalServiceType } from 'models/els';
import { GradingRadioButton } from 'models/ui';
import { Box, InfoText } from 'components/common';
import { ELSButton, ELSFlex, ELSFlexItem, ELSRadio, ELSWithModalService } from 'components/common/els';
import './grading.scss';
import { openGradingInfoModal } from 'components/common/grading-info/GradingInfoContent';

interface GradingProps {
  modalService: ELSModalServiceType;
  infoText?: string;
  assignmentGradeType: string;
  onChange: Function;
  gradingOptions: GradingRadioButton[];
}

class Grading extends Component<GradingProps> {
  handleGradingInfoClick = () => openGradingInfoModal(this.props.modalService);

  getRadioButtons = () => {
    const { assignmentGradeType, gradingOptions, onChange } = this.props;

    return gradingOptions.map((option) => (
      <ELSRadio key={option.id} id={option.id} name="assignmentGradeType" value={option.value} checked={assignmentGradeType === option.value} changeHandler={onChange}>
        <span className="els-field__label-primary-text">{option.primaryText}</span>
        {option.helperText !== '' && <span className="els-field__label-helper-text">{option.helperText}</span>}
      </ELSRadio>
    ));
  };

  render() {
    const { infoText } = this.props;

    return (
      <ELSFlex className="els-grading" center>
        <div className="els-grading-content u-els-width-3o4">
          <ELSFlex className="u-els-margin-bottom-2x" spaceBetween>
            <ELSFlexItem>
              <ELSFlex middle>
                <ELSFlexItem className="u-els-margin-right">
                  <h3 className="u-els-font-size-h3 u-els-display-inline-block">Grading</h3>
                </ELSFlexItem>
                <ELSFlexItem>
                  <ELSButton className="u-els-display-inline-block" type="link" text="How does grading work?" onClick={this.handleGradingInfoClick} />
                </ELSFlexItem>
              </ELSFlex>
            </ELSFlexItem>
            {infoText && <InfoText text={infoText} />}
          </ELSFlex>
          <Box ml>{this.getRadioButtons()}</Box>
        </div>
      </ELSFlex>
    );
  }
}

export { Grading as BaseGrading };
export default ELSWithModalService(Grading);
